import React from 'react'
import styles from './App.module.css'
import TextEditorPage from './components/TextEditorPage/TextEditorPage'
import LoginPopover from './components/LoginPopover/LoginPopoverContainer'
import classNames from 'classnames/bind'
import 'react-tippy/dist/tippy.css'
import FooterBar from './components/Footer/Footer'

let cx = classNames.bind(styles)

export default class App extends React.Component {
    render() {
        return (
            <div className={styles.contentWrapper}>
                <div
                    className={cx({
                        bottomLayer: true,
                        blurred: this.props.modalStates.isLoginSectionOpen,
                    })}
                >
                    <TextEditorPage />
                    <FooterBar />
                </div>
                {this.props.modalStates.isLoginSectionOpen ? (
                    <div className={styles.topLayer}>
                        <LoginPopover />
                    </div>
                ) : null}
            </div>
        )
    }
}
